<template>
  <div class="container">
    <l-container>
      <ul class="nav">
        <li
          v-for="(item,index) in navList"
          v-show="item.isShow"
          :key="index"
          :class="currentNavIndex==index?'active':''"
          @click="selectNav(index)"
        >{{item.navName}}</li>
      </ul>
      <router-view />
    </l-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList: [
        {
          navName: "单位简介",
          url: "/setting/companySynopsis",
          isShow: true,
        },
        {
          navName: "系统设置",
          url: "/setting/systemSetting",
          isShow:
            JSON.parse(localStorage.getItem("userinfo")).level !== 0 &&
            JSON.parse(localStorage.getItem("userinfo")).level !== 3,
        },
        {
          navName: "资料备份",
          url: "/setting/dataBackups",
          isShow:
            JSON.parse(localStorage.getItem("userinfo")).level == 2,
        },
        {
          navName: "回收站",
          url: "/setting/recycleBin",
          isShow:
            JSON.parse(localStorage.getItem("userinfo")).level !== 0 &&
            JSON.parse(localStorage.getItem("userinfo")).level !== 3,
        },
        {
          navName: "数据同步",
          url: "/setting/dataSynchronism",
          isShow:
            JSON.parse(localStorage.getItem("userinfo")).level !== 0 &&
            JSON.parse(localStorage.getItem("userinfo")).level !== 3,
        },
      ],
      currentNavIndex: 0,
    };
  },
  methods: {
    //选择导航栏
    selectNav(index) {
      this.currentNavIndex = index;
      this.$router.push(this.navList[this.currentNavIndex].url);
    },
    // 获取账号level
    getLevel() {
      console.log(JSON.parse(localStorage.getItem("userinfo")).level);
      return;
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.container {
  /deep/.el-pagination {
    bottom: 22px;
  }
  .nav {
    display: flex;
    li.active {
      height: 50px;
      line-height: 50px;
      padding: 0 25px 0 27px;
      box-sizing: border-box;
      opacity: 1;
      background: #3170ff;
      border-radius: 25px;
      font-size: 18px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: left;
      color: #ffffff;
      margin-right: 10px;
    }
    li {
      height: 50px;
      line-height: 50px;
      padding: 0 25px 0 27px;
      box-sizing: border-box;
      opacity: 1;
      border-radius: 25px;
      font-size: 18px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: left;
      color: #ffffff;
      margin-right: 10px;
    }
  }
}
</style>